// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Pervasives from "../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Spread$Showside from "./Spread.bs.js";
function noNegativity(bool) {
  if (bool) {
    return "true";
  }
}
function DataAttribute(Props) {
  var dataDisabled = Props.dataDisabled;
  var dataActive = Props.dataActive;
  var dataTestId = Props.dataTestId;
  var dataId = Props.dataId;
  var dataSectionId = Props.dataSectionId;
  var dataCount = Props.dataCount;
  var dataOriginalSrc = Props.dataOriginalSrc;
  var dataFitRule = Props.dataFitRule;
  var dataVideoMuted = Props.dataVideoMuted;
  var dataVideoLoop = Props.dataVideoLoop;
  var dataInitiator = Props.dataInitiator;
  var ariaExpanded = Props.ariaExpanded;
  var ariaChecked = Props.ariaChecked;
  var ariaLive = Props.ariaLive;
  var fetchPriority = Props.fetchPriority;
  var loading = Props.loading;
  var children = Props.children;
  var disablePictureInPicture = Props.disablePictureInPicture;
  var props = {
    "data-disabled": Belt_Option.flatMap(dataDisabled, noNegativity),
    "data-active": Belt_Option.flatMap(dataActive, noNegativity),
    "data-id": dataId,
    "data-testid": dataTestId,
    "data-section-id": dataSectionId,
    "data-count": Belt_Option.map(dataCount, function (prim) {
      return String(prim);
    }),
    "data-original-src": dataOriginalSrc,
    "data-fit-rule": dataFitRule,
    "data-initiator": dataInitiator,
    fetchpriority: fetchPriority,
    "data-video-muted": dataVideoMuted,
    "data-video-loop": dataVideoLoop,
    "aria-expanded": Belt_Option.map(ariaExpanded, Pervasives.string_of_bool),
    "aria-checked": Belt_Option.map(ariaChecked, Pervasives.string_of_bool),
    "aria-live": ariaLive,
    disablePictureInPicture: disablePictureInPicture,
    loading: loading
  };
  return React.createElement(Spread$Showside.make, {
    props: props,
    children: children
  });
}
DataAttribute.displayName = "DataAttribute";
var make = DataAttribute;
export { noNegativity, make };
/* react Not a pure module */